import state from '@/state';

const trackingInfo = require('@/utils/tracking')();

export default function callApi (method, url, body, headers = {}) {
  const data = {
    mode: 'cors',
    headers: {
      'X-GMF-Language': state.lang,
    },
    method,
  };

  for (const key in headers) {
    data.headers[key] = headers[key];
  }

  if (state.customerToken) {
    data.headers['Authorization'] = 'Bearer ' + state.customerToken;
  }

  if (state.merchantId) {
    data.headers['X-GMF-Merchant-Id'] = state.merchantId;
  }

  data.headers['X-GMF-Client-Info'] = JSON.stringify(trackingInfo);

  if (body instanceof FormData) {
    data.body = body;
  } else if (body) {
    data.headers['Content-Type'] = 'application/json';
    data.body = JSON.stringify(body);
  }

  return fetch(state.apiBase + url, data);
}
